import { useState } from 'react';
import { type DataTableRowEventHandler, ErpDataTableV2 } from '@/components/custom/erp';
import { ActionBar, EditPrintTemplateDialog, SearchDialog } from './components';
import { useKiemTraTinhTrangHoaDonDienTu, useSearchFieldStates } from './hooks';
import { KiemTraTinhTrangHoaDonDienTuSearchFormValues } from '@/types/schemas';
import { getDataTableColumns } from './cols-definition';
import { SearchFormValues } from './schemas';

export default function KiemTraTinhTrangHoaDonDienTuPage() {
  const [showTables, setShowTables] = useState(false);
  const [showSearchDialog, setShowSearchDialog] = useState(true);
  const [showEditPrintTemplateDialog, setShowEditPrintTemplateDialog] = useState(false);

  const [selectedObj, setSelectedObj] = useState<BanHangRecord | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const [dates, setDates] = useState<{ fromDate: string; toDate: string } | null>(null);
  const [searchParams, setSearchParams] = useState<KiemTraTinhTrangHoaDonDienTuSearchFormValues>({});

  // Search field states
  const searchFieldStates = useSearchFieldStates();

  // Mock data hook
  const { data, isLoading, error, fetchData } = useKiemTraTinhTrangHoaDonDienTu(searchParams);
  const handleRowClick: DataTableRowEventHandler = params => {
    if (params.row.id === 'total') return;

    const reportItem = params.row as BanHangRecord;
    setSelectedObj(reportItem);
    setSelectedRowIndex(params.row.id.toString());
  };

  const handleSearch = () => {
    setShowSearchDialog(true);
  };

  const handleSearchSubmit = async (filters: SearchFormValues) => {
    setShowSearchDialog(false);
    setShowTables(true);

    setDates({
      fromDate: `${filters.ngay_ct1}`,
      toDate: `${filters.ngay_ct2}`
    });

    const searchParameters: KiemTraTinhTrangHoaDonDienTuSearchFormValues = {
      ngay_ct1: filters.ngay_ct1,
      ngay_ct2: filters.ngay_ct2,
      so_ct1: filters.so_ct1,
      so_ct2: filters.so_ct2,
      xtype: filters.xtype
    };

    setSearchParams(searchParameters);
    await fetchData(searchParameters);
  };

  const handleRefresh = async () => {
    if (searchParams && Object.keys(searchParams).length > 0) {
      await fetchData(searchParams);
    }
  };

  const handleFixedColumns = () => {};

  const handleExportData = () => {};

  const handleEditPrintTemplate = () => {
    setShowEditPrintTemplateDialog(true);
  };

  const tables = [
    {
      name: `Kiểm tra tình trạng hóa đơn điện tử`,
      rows: data,
      columns: getDataTableColumns(),
      loading: isLoading
    }
  ];

  return (
    <div className='flex h-full min-h-screen w-screen flex-col lg:overflow-hidden'>
      <SearchDialog
        open={showSearchDialog}
        onClose={() => setShowSearchDialog(false)}
        onSearch={handleSearchSubmit}
        searchFieldStates={searchFieldStates}
      />

      <EditPrintTemplateDialog
        open={showEditPrintTemplateDialog}
        onClose={() => setShowEditPrintTemplateDialog(false)}
      />

      {showTables && (
        <div className='w-full'>
          <ActionBar
            onSearch={handleSearch}
            onRefresh={handleRefresh}
            onExportData={handleExportData}
            onFixedColumns={handleFixedColumns}
            onEditPrintTemplate={handleEditPrintTemplate}
            fromDate={dates?.fromDate}
            toDate={dates?.toDate}
          />
          {!isLoading && (
            <ErpDataTableV2 tables={tables} selectedRowId={selectedRowIndex || undefined} onRowClick={handleRowClick} />
          )}
        </div>
      )}
    </div>
  );
}
